/**
 * Center Components
 * Centering utilities
 */

import React, { forwardRef } from 'react';
import { Flex } from '../primitives/Flex';
import { Box } from '../primitives/Box';

/**
 * Center Component
 * Centers its children horizontally and vertically
 * 
 * @example
 * <Center h="100px">Centered content</Center>
 */
export const Center = forwardRef((props, ref) => {
  return (
    <Flex
      ref={ref}
      align="center"
      justify="center"
      {...props}
    />
  );
});

Center.displayName = 'Center';

/**
 * Square Component
 * A centered box with equal width and height
 * 
 * @example
 * <Square size="40px" bg="brand.500">
 *   <Icon />
 * </Square>
 */
export const Square = forwardRef(({
  size,
  ...props
}, ref) => {
  return (
    <Center
      ref={ref}
      boxSize={size}
      flexShrink={0}
      {...props}
    />
  );
});

Square.displayName = 'Square';

/**
 * Circle Component
 * A rounded Square
 * 
 * @example
 * <Circle size="40px" bg="brand.500">
 *   <Icon />
 * </Circle>
 */
export const Circle = forwardRef((props, ref) => {
  return (
    <Square
      ref={ref}
      borderRadius="full"
      {...props}
    />
  );
});

Circle.displayName = 'Circle';

export default Center;
